import { useEffect, useState } from "react";

export function UpdatePrompt() {
	const [show, setShow] = useState(false);
	const [updateFn, setUpdateFn] = useState<((reloadPage?: boolean) => Promise<void>) | null>(null);

	useEffect(() => {
		const handler = (e: Event) => {
			const detail = (e as CustomEvent).detail;
			setUpdateFn(() => detail.updateSW);
			setShow(true);
		};
		window.addEventListener("sw-update-available", handler);
		return () => window.removeEventListener("sw-update-available", handler);
	}, []);

	if (!show) return null;

	return (
		<div
			className="fixed bottom-20 left-4 right-4 lg:bottom-4 lg:left-auto lg:right-4 lg:w-96"
			style={{ zIndex: "var(--z-index-banner)" }}
		>
			<div className="rounded-lg bg-surface border border-border p-4 shadow-lg">
				<p className="text-base font-medium text-text">Neue Version verfügbar</p>
				<p className="mt-1 text-base text-text-muted">
					Die App wurde aktualisiert. Jetzt neu laden?
				</p>
				<div className="mt-3 flex gap-2">
					<button
						type="button"
						onClick={() => {
							if (updateFn) updateFn(true);
						}}
						className="rounded-md bg-primary px-3 py-1.5 text-base font-medium text-white hover:bg-primary/90 cursor-pointer"
					>
						Aktualisieren
					</button>
					<button
						type="button"
						onClick={() => setShow(false)}
						className="rounded-md bg-surface-dim px-3 py-1.5 text-base font-medium text-text hover:bg-surface-dim/80 cursor-pointer"
					>
						Später
					</button>
				</div>
			</div>
		</div>
	);
}
